import { useState } from "react";
import { motion } from "framer-motion";
import { ChefHat, MessageCircle, Utensils } from "lucide-react";
import BranchChooser from "./BranchChooser";

const cateringImg =
    "https://images.unsplash.com/photo-1559847844-5315695dadae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function Catering() {
    const [open, setOpen] = useState(false);
    return (
        <section
            id="catering"
            data-testid="catering-section"
            className="relative py-24 lg:py-36 bg-cream"
        >
            <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8 }}
                >
                    <span className="eyebrow flex items-center gap-3">
                        <span className="w-8 h-px bg-gold" />
                        Beyond the Spa
                    </span>
                    <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl text-maroon tracking-tight leading-[1.05]">
                        Thai Catering &{" "}
                        <em className="font-light text-gold-dark">Private Events</em>.
                    </h2>
                    <p className="mt-7 text-base lg:text-lg text-ink-soft font-light leading-relaxed">
                        We bring authentic Thai flavours straight to your venue. From an intimate
                        dinner at home to a full pop-up Thai restaurant experience for your guests —
                        we plan, cook and serve, so you simply enjoy the evening.
                    </p>

                    <ul className="mt-7 space-y-3 text-ink-soft">
                        <li className="flex items-start gap-3">
                            <ChefHat size={18} className="text-gold-dark mt-1 shrink-0" />
                            <span>Authentic Thai catering for any occasion</span>
                        </li>
                        <li className="flex items-start gap-3">
                            <Utensils size={18} className="text-gold-dark mt-1 shrink-0" />
                            <span>Pop-up Thai restaurant set up at your location</span>
                        </li>
                        <li className="flex items-start gap-3">
                            <MessageCircle size={18} className="text-gold-dark mt-1 shrink-0" />
                            <span>Custom menus, tastings and full event support</span>
                        </li>
                    </ul>

                    <button
                        onClick={() => setOpen(true)}
                        data-testid="catering-enquire-btn"
                        className="btn-maroon mt-10"
                    >
                        <MessageCircle size={18} />
                        Enquire about catering
                    </button>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8, delay: 0.15 }}
                    className="relative"
                >
                    <div className="aspect-[4/5] overflow-hidden">
                        <img
                            src={cateringImg}
                            alt="Authentic Thai catering"
                            className="w-full h-full object-cover"
                        />
                    </div>
                    <div className="absolute -bottom-5 -left-5 lg:-left-10 bg-maroon text-cream px-6 py-5 max-w-[260px] border border-gold/30 hidden md:block">
                        <p className="font-serif text-xl italic text-gold-light leading-tight">
                            “Bring Thailand to your table.”
                        </p>
                    </div>
                </motion.div>
            </div>

            <BranchChooser
                open={open}
                onOpenChange={setOpen}
                title="Enquire about catering"
                description="Send a quick WhatsApp message — we'll reply with menu options & pricing."
                message="Hi, I'd like to enquire about Thai catering / private event services from Aekkarag. Please share details."
            />
        </section>
    );
}
